import { SeverityLevel } from '@sentry/core'

import type { Level } from './types'
// the package is very small


export const levels = {
  fatal: 0,
  error: 1,
  warning: 2,
  info: 3,
  http: 4,
  verbose: 5,
  debug: 6,
}

export const isLevelFit = (entryLevel: Level, middlewareLevel: Level) => {
  return levels[entryLevel] <= levels[middlewareLevel]
}

export const getSentryLevel = (level: Level): SeverityLevel => {
  return level
}
